import { render } from "./CreateTransferPage.vue?vue&type=template&id=f354cace&ts=true"
import script from "./CreateTransferPage.vue?vue&type=script&lang=ts"
export * from "./CreateTransferPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__